module.exports = "/img/document.46fe3035.png";